"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const ReactDOM = __importStar(require("react-dom"));
const react_router_dom_1 = require("react-router-dom");
const App_1 = require("src/hello_assets/src/components/ui/App");
const use_query_params_1 = require("use-query-params");
require("./css/theme/default/default.less");
console.log("process.env.NODE_ENV", process.env.NODE_ENV);
console.log("process.env.COORDINATOR_CANISTER_IDS", process.env.COORDINATOR_CANISTER_IDS);
ReactDOM.render(React.createElement(react_router_dom_1.BrowserRouter, null,
    React.createElement(use_query_params_1.QueryParamProvider, { ReactRouterRoute: react_router_dom_1.Route },
        React.createElement(App_1.App, null))), document.getElementById('root'));
